export enum ActionTypes {
    USER_LOGIN_FAILURE = 'USER_LOGIN_FAILURE',
    USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST',
    USER_LOGIN_VERIFYING = 'USER_LOGIN_VERIFYING',
    USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS',
    USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS',

    PROFILE_DRAWER_SHOWED = 'PROFILE_DRAWER_SHOWED',
    PROFILE_PROJECTS_LOADED = 'PROFILE_PROJECTS_LOADED',
    
}



// WEBPACK FOOTER //
// ./src/types/action-types.ts